import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Card, ListGroup, Accordion } from 'react-bootstrap';
import './formato.css';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import { useHistory, useParams } from 'react-router-dom';
import { postCompanion, obtenAcompanantes, fechaInvitacion, putCompanion } from 'services/rsvp/getRSVP';
import { Modal } from 'components';
import styles from './styles.module.scss';
import nextIcon from 'assets/img/next.svg';
import masIcon from 'assets/img/mas.png';
//import { set } from 'lodash';
import { useWindowSize } from 'hooks';
const MyCompanionAdd = ({ typeId }) => {

  const history = useHistory();
  const [, { isMobile }] = useWindowSize();
  const { guestId } = useParams();

  const [id, setId] = useState('');
  const [nombre, setNombre] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [correo, setCorreo] = useState('');
  const [edad, setEdad] = useState('');
  const [telefono, setTelefono] = useState('');
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [jsonResultado, setJsonResultado] = useState(null);
  const [servicioAcompanantes, setServicioAcompanantes] = useState('');
  const [refreshAcompañante, setRefreshAcompañante] = useState(false);
  const [mostrarSeccionAcompañantes, setMostrarSeccionAcompañantes] = useState(false);
  const [mostrarBotonActualizar, setMostrarBotonActualizar] = useState(false);
  const [mostrarBotonGuardar, setMostrarBotonGuardar] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const handleRegresarClick = () => {
    history.push('/muestra-invitados');
  };

  const handleClose = () => {
    setShowModal(false);
    history.push('/muestra-invitados');
  };

  const handleSendInvitation = () => {
    alert('enviar invitacion a invitado: ' + guestId);
  };

  // Función para manejar el envío del formulario
  const handleSubmit = (e) => {
    // activa patalla de cargando
    dispatch(showLoader());

    e.preventDefault();

    // Crear el objeto JSON con los datos del formulario
    let idguest = guestId;
    const nuevoRegistro = {
      id,
      typeId,
      idguest,
      nombre,
      apellidos,
      correo,
      edad,
      telefono,
    };

    // Actualizar el estado del resultado JSON
    setJsonResultado(nuevoRegistro);

  };

  const handleNameClick = (acompanante) => {
    //alert(`ID: ${acompanante.id}`);
    setId(acompanante.id);
    setNombre(acompanante.name);
    setApellidos(acompanante.last_name);
    setCorreo(acompanante.email);
    setEdad(acompanante.age);
    setTelefono(acompanante.phone);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMostrarBotonActualizar(true);
    setMostrarSeccionAcompañantes(false);
    //setMo


    //  MOSTRAR BOTON ACTUALIZA ACOMPAÑANTE
  };

  const handleConfirma = () => {
    //    SERIVIO OBTEN FECHA EVENTO
    fechaInvitacion(typeId).then((valorDeServicio) => {
      console.log('serviciofechaInvitacion ', valorDeServicio?.data?.items);
      const fechaActual = new Date();
      const fechaEventoServicio = valorDeServicio?.data?.items;
      const partesFecha = fechaEventoServicio.split("/");
      const dia = parseInt(partesFecha[0], 10);
      const mes = parseInt(partesFecha[1], 10) - 1; // Los meses en JavaScript van de 0 a 11
      const año = 2000 + parseInt(partesFecha[2], 10);
      const fechaEvento = new Date(año, mes, dia);

      // Valida la respuesta del backend Si la fecha es mayor redirect a muestra invitados en caso contrario muestra modal
      if (fechaActual < fechaEvento) {
        //alert ('Redireciona a muestra invitados');
        history.push('/muestra-invitados');
      } else {
        //alert ('Muestra modal');
        setShowModal(true);
      }
    });
  };

  const handleAddCompanions = () => {
    setNombre('');
    setApellidos('');
    setCorreo('');
    setEdad('');
    setTelefono('');
    setMostrarSeccionAcompañantes(false);
    setMostrarBotonGuardar(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (jsonResultado !== null) {
      //  alert('JsonResultado ' + JSON.stringify(jsonResultado, null, 2));           // Eliminar 
      // Limpiar los campos del formulario
      setJsonResultado(null);
      setNombre('');
      setApellidos('');
      setCorreo('');
      setEdad('');
      setTelefono('');

      if (jsonResultado.id !== '') {
        //alert ('actualizar acompañante');
        setId('');
        // Enviar el objeto JSON al backend para guardar en la base de datos
        putCompanion(jsonResultado.id, jsonResultado).then((valorDeServicio) => {
          console.log('putCompanion ', valorDeServicio);
          setRefreshAcompañante(!refreshAcompañante);
          setMostrarSeccionAcompañantes(true);
          setMostrarBotonActualizar(false);
          setMostrarBotonGuardar(false);
          dispatch(hideLoader());
        });
      } else {
        //alert ('guardar acompañante');
        // Enviar el objeto JSON al backend para guardar en la base de datos
        postCompanion(typeId, jsonResultado).then((valorDeServicio) => {
          console.log('postCompanion ', valorDeServicio);
          // Valida la respuesta del backend
          setRefreshAcompañante(!refreshAcompañante);
          setMostrarSeccionAcompañantes(true);
          setMostrarBotonActualizar(false);
          setMostrarBotonGuardar(false);
          dispatch(hideLoader());
        });
      }
    }
  }, [jsonResultado]);

  useEffect(() => {
    dispatch(showLoader());
    obtenAcompanantes(guestId).then((valorDeServicio) => {
      console.log('obtenAcompanantes ', valorDeServicio);

      // Valida la respuesta del backend
      if (valorDeServicio?.metadata?.http_status == 200) {
        setServicioAcompanantes(valorDeServicio?.data?.items);
      }

      // desactiva patalla de cargando y redireciona
      dispatch(hideLoader());
    });
  }, [refreshAcompañante]);

  const handleTelefonoChange = (event) => {
    // Expresión regular que permite solo números
    const regex = /^[0-9]+$/;
    const inputValue = event.target.value;

    if (regex.test(inputValue) || inputValue === '') {
      setTelefono(inputValue);
    }
  };

  console.log('mostrarSeccionAcompañantes ', mostrarSeccionAcompañantes);
  return (
    <>
      {!isMobile && (
        <>
          <span className="float-left" onClick={handleRegresarClick}><i class="fa fa-arrow-left" aria-hidden="true"></i>  Regresar</span><br />
        </>
      )}
      <h1>Agrega acompañante</h1>
      <h5>Ingresa los datos del acompañante</h5>
      <div>
        <form onSubmit={handleSubmit}>
          <div className="campo">
            <label>Nombre:</label>
            <input
              type="text"
              placeholder="Nombre del invitado"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
              className={`${styles.inputsborder} form-control`}
            />
          </div>
          <div className="campo">
            <label>Apellidos:</label>
            <input
              type="text"
              placeholder="Apellidos del invitado"
              value={apellidos}
              onChange={(e) => setApellidos(e.target.value)}
              required
              className={`${styles.inputsborder} form-control`}
            />
          </div>
          <div className="campo">
            <label>Correo:</label>
            <input
              type="email"
              placeholder="Correo del invitado"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
              required
              className={`${styles.inputsborder} form-control`}
            />
          </div>
          <div className="campo">
            <label>Edad:</label>
            <select
              value={edad}
              onChange={(e) => setEdad(e.target.value)}
              required
              className={`${styles.inputsborder} form-control`}
            >
              <option value="">Edad</option>
              <option value="adulto">Adulto</option>
              <option value="niño">Niño</option>
              <option value="bebe">Bebé</option>
            </select>
          </div>
          <div className="campo">
            <label>Teléfono:</label>
            <input
              type="tel"
              placeholder="Número de teléfono del invitado"
              value={telefono}
              onChange={(e) => handleTelefonoChange(e) }
              required
              className={`${styles.inputsborder} form-control`}
            />
          </div>
          {
            mostrarBotonGuardar &&
            <div className="campo">
              <Button variant="primary" type="submit"> Guardar </Button>
            </div>
          }
          {
            mostrarBotonActualizar &&
            <div className="campo">
              <Button variant="primary" type="submit"> Actualizar </Button>
            </div>
          }
        </form>
        {mostrarSeccionAcompañantes &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Card style={{ width: '24rem', border: 'none' }}>
              <span style={{ textAlign: 'left', marginLeft: '24px' }}><b>Acompañantes</b></span>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <Accordion defaultActiveKey="0">
                    <Card style={{ borderRadius: '20px' }}>
                      <Card.Header style={{ backgroundColor: '#fff' }}>
                        <Accordion.Toggle as={Card.Text} variant="link" eventKey="0">
                          Nombre Invitado
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          <ul className="list-group" style={{ textAlign: 'center' }}>
                            {servicioAcompanantes.length > 0 &&
                              servicioAcompanantes.map((acompanante) => (
                                <li className="list-group-item d-flex justify-content-between" key={acompanante.id} style={{ cursor: 'pointer' }} onClick={() => handleNameClick(acompanante)}>
                                  <span>{acompanante.name} {acompanante.last_name}</span>
                                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                                </li>
                              ))}
                            <li style={{ cursor: 'pointer', listStyle: 'none', padding: '20px' }} onClick={handleAddCompanions}>
                              <img src={masIcon} width="20" height="20" /> Agregar acompañante
                            </li>
                          </ul>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                  <Button variant="primary" onClick={handleConfirma} style={{ marginTop: '10px', width: '100%' }}>
                    Confirmar
                  </Button>
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </div>
        }
      </div>

      <Modal
        size="md"
        withActionButtons={false}
        show={showModal}
        onClose={handleClose}
        variant="completed"
        variantOnlyInMobile
        showCancel={false}
        withHeader={false}
      >
        <Row className="pb-4">
          <Col xs={12} className="d-flex justify-content-center align-items-center">
            <h2><b>¡La fecha del envío ya<br />pasó!</b></h2>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col className="text-center">
            La fecha del envío<br />programada para las<br />invitaciones ya pasó.
          </Col>
        </Row>
        <Row className="pb-4">
          <Col className="text-center">
            <Button variant="primary" onClick={handleSendInvitation} block>
              Enviar ahora invitación
            </Button>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col className="text-center">
            <Button variant="secondary" onClick={handleClose} block>
              Enviar más tarde
            </Button>
          </Col>
        </Row>
      </Modal>

    </>
  );
};

export default MyCompanionAdd;
